import { createUseStyles } from 'react-jss';
export const useTabStyles = createUseStyles(() => ({
    tab: {
        border: 'none',
        color: '#525866',
        backgroundColor: 'transparent',
        padding: '0.75rem 1rem',
        position: 'relative',
        '&[data-selected]': {
            color: '#0A0D14',
            fontWeight: 500,
            outline: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                bottom: '-1px',
                left: 0,
                right: 0,
                height: '2px',
                backgroundColor: '#375DFB'
            }
        }
    }
}));
